import { useEffect } from 'react';
import { useParams } from 'react-router';

import { Loader } from 'modules/v2/common/components';
import { withDraft } from 'modules/v2/draft/containers';
import { JourneyContextProvider } from 'modules/v2/context/JourneyContextProvider';

import { isPending } from 'store/status';

const Draft = ({ draft, getDraftById, children }) => {
  const { draftId } = useParams();

  useEffect(() => {
    getDraftById(draftId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [draftId]);

  if (isPending(draft.status)) {
    return <Loader title="Loading Book" />;
  }

  return <JourneyContextProvider>{children}</JourneyContextProvider>;
};

export default withDraft(Draft);
